import { Alert, Text } from '@nimbus-ds/components';
import { useTranslationCommon } from 'commons/hooks';

interface AlertMaxImagesProps {
  maxImagesToLoad: number;
  onRemove: () => void;
}

function AlertMaxImages({
  maxImagesToLoad,
  onRemove,
}: Readonly<AlertMaxImagesProps>) {
  const t = useTranslationCommon();
  return (
    <Alert appearance="warning" show onRemove={onRemove}>
      <Text>
        {t('alertImagesExceededQuantity', {
          maxImagesToLoad,
        })}
      </Text>
    </Alert>
  );
}

export default AlertMaxImages;
